import { useEffect, useState } from "react";
// Components
import {
  CurrentPageInputField,
  GoToBackBtn,
  GoToNextBtn,
  ItemsPerPageSelector,
  MoveToFirstPageBtn,
  MoveToLastPageBtn,
} from "./components";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import {
  notificationCenterLimitAction,
  notificationCenterPaginationAction,
  notificationsLimitAction,
  notificationsPaginationAction,
} from "store/filters/reducer.actions";
// types
import { PaginationProps, handleChangeOnCurrentPageInputField } from "./types";
import { filtersInitialState } from "store/filters/initialState";
import { IfetchNotifications } from "store/notificationCenter/initialState";

export const Pagination: React.FC<PaginationProps> = ({}) => {
  const [pageInput, setPageInput] = useState("");
  const { notificationCenterFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const { data } = useSelector<RootState, IfetchNotifications>(
    (state) => state?.notificationCenter
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setPageInput(notificationCenterFilter.page.toString());
  }, [notificationCenterFilter.page]);

  // Handlers
  const handleChangeItemsPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { value } = event.target;
    dispatch(notificationCenterLimitAction(parseInt(value)));
  };
  const handleClickOnMoveToFirstPageBtn = () => {
    dispatch(notificationCenterPaginationAction(1));
  };
  const handleClickOnGoToBackBtn = () => {
    dispatch(
      notificationCenterPaginationAction(
        notificationCenterFilter.page > 1 ? notificationCenterFilter.page - 1 : 1
      )
    );
  };
  const handleClickOnGoToNextBtn = () => {
    dispatch(
      notificationCenterPaginationAction(
        notificationCenterFilter.page < data.totalPages
          ? notificationCenterFilter.page + 1
          : data.totalPages
      )
    );
  };
  const handleClickOnMoveToLastPageBtn = () => {
    dispatch(notificationCenterPaginationAction(data.totalPages));
  };
  const handleChangeOnCurrentPageInputField: handleChangeOnCurrentPageInputField =
    (e) => {
      const value = e.target.value;
      setPageInput((prevValue: any) => {
        if (value === "" || !isNaN(parseInt(value))) {
          if (parseInt(value) <= data.totalPages && parseInt(value) > 0) {
            if (!isNaN(parseInt(value))) {
              dispatch(notificationCenterPaginationAction(parseInt(value)));
            } else {
              dispatch(notificationCenterPaginationAction(1));
            }

            return value;
          }
        }
        return "";
      });
    };
  const handleBlurOnCurrentPageInputField = () => {
    setPageInput(notificationCenterFilter.page.toString());
  };
  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 px-6 pt-8 pb-10 bg-white dark:bg-secondaryLight rounded-bl-lg rounded-br-lg">
      <div className="flex items-center justify-start flex-grow">
        <ItemsPerPageSelector
          handleChangeItemsPerPage={handleChangeItemsPerPage}
          limit={notificationCenterFilter.limit}
        />
        <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-2">
          <MoveToFirstPageBtn
            page={notificationCenterFilter.page}
            handleClickOnBtn={handleClickOnMoveToFirstPageBtn}
          />
          <CurrentPageInputField
            pageInput={pageInput}
            handleChangeOnInput={handleChangeOnCurrentPageInputField}
            handleBlurOnInput={handleBlurOnCurrentPageInputField}
          />
          <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-1 px-3 py-1 rounded-lg">
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-0.5">
              <p className="flex-grow-0 flex-shrink-0 text-[15px] text-center text-textMid dark:text-caption ">
                of {data.totalPages}
              </p>
            </div>
          </div>
          <GoToBackBtn
            page={notificationCenterFilter.page}
            handleClickOnBtn={handleClickOnGoToBackBtn}
          />
          <GoToNextBtn
            page={notificationCenterFilter.page}
            totalPages={data.totalPages}
            handleClickOnBtn={handleClickOnGoToNextBtn}
          />

          <MoveToLastPageBtn
            page={notificationCenterFilter.page}
            totalPages={data.totalPages}
            handleClickOnBtn={handleClickOnMoveToLastPageBtn}
          />
        </div>
      </div>
    </div>
  );
};
